import React from "react";
import { Button, Paper, Stack, Typography } from "@mui/material";

import { MeetingStatus } from "../../../types";
import { useEventCalendarValues } from "../../../routes/calendar/calendar-context";
import {
  getCalendarMeetingTypeColor,
  getCalendarMeetingTypeLabel,
  getCalendarMeetingTypes,
} from "../calendar-status-utils";

const TypeFilter: React.FC = () => {
  const {
    visibleMeetingTypes,
    toggleVisibleMeetingType,
    updateVisibleMeetingTypes,
  } = useEventCalendarValues();
  const meetingTypes = getCalendarMeetingTypes();
  const toggleableMeetingTypes = meetingTypes.filter(
    (meetingType) => meetingType !== MeetingStatus.Proposed,
  );

  const isSelected = (meetingType: MeetingStatus) => {
    return visibleMeetingTypes.includes(meetingType);
  };

  return (
    <Stack
      sx={{
        px: 1.25,
        py: 1.25,
        borderRadius: 1.5,
        backgroundColor: "#F7F9FC",
      }}
    >
      <Stack spacing={1.25}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            Meeting types
          </Typography>
          <Stack direction="row" spacing={0.5}>
            <Button
              size="small"
              onClick={() => updateVisibleMeetingTypes(meetingTypes)}
              sx={{ minWidth: 0, px: 0.5, fontSize: "0.68rem", fontWeight: 700 }}
            >
              ALL
            </Button>
            <Button
              size="small"
              onClick={() => updateVisibleMeetingTypes([MeetingStatus.Proposed])}
              sx={{ minWidth: 0, px: 0.5, fontSize: "0.68rem", fontWeight: 700 }}
            >
              NONE
            </Button>
          </Stack>
        </Stack>
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
          {toggleableMeetingTypes.map((meetingType) => {
            const selected = isSelected(meetingType);

            return (
              <Paper
                key={meetingType}
                elevation={0}
                onClick={() => toggleVisibleMeetingType(meetingType)}
                sx={{
                  px: 1.25,
                  py: 0.9,
                  borderRadius: 1.5,
                  cursor: "pointer",
                  backgroundColor: getCalendarMeetingTypeColor(meetingType),
                  border: selected ? "1px solid transparent" : "1px solid rgba(0,0,0,0.16)",
                  opacity: selected ? 1 : 0.38,
                  transition: "transform 0.15s ease, opacity 0.15s ease, box-shadow 0.15s ease",
                  boxShadow: selected ? "0px 2px 8px rgba(0,0,0,0.12)" : "none",
                  userSelect: "none",
                  "&:hover": {
                    opacity: selected ? 0.92 : 0.6,
                    transform: "translateY(-1px)",
                  },
                }}
              >
                <Typography
                  sx={{
                    color: "#FFFFFF",
                    fontSize: "0.75rem",
                    fontWeight: 700,
                    lineHeight: 1,
                  }}
                >
                  {getCalendarMeetingTypeLabel(meetingType)}
                </Typography>
              </Paper>
            );
          })}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default TypeFilter;